import { render } from "./ImageDetail.vue?vue&type=template&id=5272af70&scoped=true"
import script from "./ImageDetail.vue?vue&type=script&lang=js"
export * from "./ImageDetail.vue?vue&type=script&lang=js"

import "./ImageDetail.vue?vue&type=style&index=0&id=5272af70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5272af70"]])

export default __exports__